class CopyToClipboard extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', () => this.copyToClipboard());
  }

  /**
   * Copy to clipboard
   */
  async copyToClipboard() {
    try {
      await navigator.clipboard.writeText(this.dataset.value);
      window.toast.success(this.dataset.successMessage || 'Copied to clipboard');
    } catch (error) {
      window.toast.error(error.message);
    }
  }
}

customElements.define('copy-to-clipboard', CopyToClipboard);
